class Region < ApplicationRecord
  self.inheritance_column = nil
end
